import { isHttpError } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'

// A repository that rethrows the raw HttpError leaves getMessageFromError with
// only the generic "HTTP Error <status>" copy; surface the API's
// `errors.detail.message` when present instead.
export const getApiDetailMessage = (error: unknown): string | undefined =>
  isHttpError(error) ? error.response?.errors?.detail?.message : undefined
